<template>
  <v-container class="pa-0">
    <v-row no-gutters>
      <v-col :cols="12">
        <FormHeader title="SETTINGS" />
      </v-col>
    </v-row>
    <v-container class="white pt-8">
      <v-row no-gutters align="baseline" class="pb-3">
        <v-col cols="2">
          <v-subheader>BROWSER TYPE</v-subheader>
        </v-col>
        <v-col cols="10" class="pl-4">
          <v-radio-group v-model="v.$model.browser_type" row>
            <v-radio
              :name="item.title"
              v-for="item in browserType"
              :key="item.title"
              :label="item.title"
              :value="item.value"
              color="success"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row no-gutters align="baseline">
        <v-col cols="2">
          <v-subheader>BROWSER</v-subheader>
        </v-col>
        <v-col cols="9" class="pl-4 userAgentWrap">
          <v-sheet>
            <v-select
              id="userAgent"
              v-model="v.$model.device"
              return-object
              item-value="id"
              required
              @blur="v.device.$touch()"
              @input="v.device.$touch()"
              :error-messages="errorMessages.requiredUserAgent(v.device)"
              outlined
              placeholder="Select User Agent"
              :items="getUserAgents"
              dense
              single-line
            >
              <template v-slot:selection="{ item }">
                <v-list-item-title>
                  {{ item.section }} - {{ item.device }}
                </v-list-item-title>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-title v-if="!item.id" class="grey--text">
                  {{item.section}}
                </v-list-item-title>
                <v-list-item-title v-else>
                  > &nbsp;{{ item.device }}
                </v-list-item-title>
              </template>
            </v-select>
            <p class="body-2">
              {{ v.$model.device.device }}
            </p>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row no-gutters align="baseline">
        <v-col cols="2">
          <v-subheader>PROXY TYPE</v-subheader>
        </v-col>
        <v-col cols="10" class="pl-4">
          <v-radio-group v-model="v.$model.proxy_type" row>
            <v-radio
                    :name="item.title"
                    v-for="item in proxyType"
                    :key="item.id"
                    :label="item.title"
                    :value="item.value"
                    v-on:change="filterLocationByProxyType(item.value)"
                    color="success"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row> 
      <v-row no-gutters align="baseline">
        <v-col cols="2">
          <v-subheader>LOCATION</v-subheader>
        </v-col>
        <v-col cols="9" class="pl-4 pb-3">
          <v-sheet>
            <v-select
              id="location"
              return-object
              v-model="v.$model.location"
              item-value="id"
              item-text="name"
              required
              @blur="v.location.$touch()"
              :error-messages="errorMessages.requiredErrors(v.location)"
              dense
              single-line
              outlined
              :items="filteredLocations"
              placeholder="Select Location"
            />
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import FormHeader from "./FormHeader";
import { createNamespacedHelpers } from "vuex";
const formHelper = createNamespacedHelpers("form");
export default {
  name: "SettingsForm",
  components: { FormHeader },
  data: function () {
    return {
      filteredLocations: []
    }
  },
  props: {
    errorMessages: {
      type: Object,
      required: true
    },
    v: {
      type: Object,
      required: true
    },
    proxyType: Array,
    browserType: Array,
  },
  watch: {
    getLocations: function (newVal) {
      this.filteredLocations = [...newVal];
    },
    $attrs: function (newVal) {
      this.filterLocationByProxyType(newVal.value.proxy_type)
    }
  },
  computed: {
    ...formHelper.mapGetters(["getLocations", "getUserAgents"]),
      convertedType: {
        get: function() {
          return this.v.$model.type ? this.v.$model.type : this.proxyType[0].value;
        },
        set: function(newValue) {
          this.v.$model.type = newValue;
        }
      },
  },
  methods: {
    filterLocationByProxyType (type) {
      const isDatacenter = type === "datacenter";
      const isResidential = type === "residential";
      if (isDatacenter) {
        this.filteredLocations = this.getLocations.filter(({is_datacenter}) => is_datacenter);
      } else if (isResidential)  {
        this.filteredLocations = this.getLocations.filter(({is_residential}) => is_residential);
      } else {
        this.filteredLocations = this.getLocations;  
      }
    }
  },
  created() {
    this.convertedType.get;
  }
};
</script>
